import { render, staticRenderFns } from "./BaseKachelFotos.vue?vue&type=template&id=65e3a709&"
import script from "./BaseKachelFotos.vue?vue&type=script&lang=js&"
export * from "./BaseKachelFotos.vue?vue&type=script&lang=js&"
import style0 from "./BaseKachelFotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports